module.exports = __webpack_public_path__ + "media/images/official/special_exchange-83b8808246c5e05c579b9cd092c59ce8.jpg";